(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("authorityToRecruitDataService", AuthorityToRecruitDataService);

    AuthorityToRecruitDataService.$inject = ['$q'];

    function AuthorityToRecruitDataService($q) {

        var self = this;

        var brandATRSettingsCache = {};

        self.isPositionEligibleForATRSync = function (atrSettings, positionCode) {
            if (!atrSettings) {
                console.error("ATR Settings is not provided for position check");
                return;
            }

            if (atrSettings.atr_type === 'BNB_WORKDAY') {
                return !!(atrSettings.positions.find(function (item) {
                    return item.code === positionCode;
                }));
            } else {
                return true;
            }
        };

        self.isPositionEligibleForATR = function (brandId, positionCode) {
            var defer = $q.defer();

            self.getATRSettings(brandId)
                .then(function (atrSettings) {
                    defer.resolve(self.isPositionEligibleForATRSync(atrSettings, positionCode));
                })
                .catch(function (err) {
                    console.error("Failed to load ATR Settings for brand id:", brandId);
                    defer.reject(err);
                });

            return defer.promise;
        };

        self.getATRSettings = function (brandId) {
            var defer = $q.defer();

            if (brandATRSettingsCache[brandId]) {
                defer.resolve(brandATRSettingsCache[brandId]);
            }
            else {
                ATRAPI.getBrandSettings(brandId)
                    .then(function (res) {
                        brandATRSettingsCache[brandId] = res;
                        defer.resolve(brandATRSettingsCache[brandId]);
                    })
                    .catch(function (err) {
                        defer.reject(err);
                    });
            }

            return defer.promise;
        };

        self.clearBrandATRSettings = function (brandId) {
            brandATRSettingsCache[brandId] = null;
        }
    }
})();
